import {
  getDashboardData,
  getMypropertiesData,
  getMytenanciesData,
  getMyoffersData,
  getMyappointmentsData,
  postAppointment,
  postForm,
  getProperties,
  getProperty,
} from '../api';

const services = (dispatch, actions) => ({
  postForm: (payload) => {
    dispatch(actions.myaccountActions('FORM_LOADING'));
    postForm(payload)
      .then((res) => {
        dispatch(actions.myaccountActions('FORM_POST_SUCCESS', res));
      })
      .catch((error) => {
        // Login failed
        if (error.response) {
          // Login error
          dispatch(
            actions.myaccountActions('FORM_POST_ERROR', {
              message: error.response.data.message,
              status: error.response.status,
            })
          );
        } else {
          // Service error
          dispatch(
            actions.myaccountActions('FORM_POST_ERROR', {
              message: 'Api service Down',
              status: 500,
            })
          );
        }
      });
  },
  getDashboardData: (payload) => {
    getDashboardData(payload).then((res) => {
      dispatch(actions.myaccountActions('GET_DASHBOARD_DATA', res.data));
    });
  },
  getMypropertiesData: (payload) => {
    dispatch(actions.myaccountActions('DATA_LOADING'));
    getMypropertiesData(payload).then((res) => {
      dispatch(actions.myaccountActions('GET_MYPROPERTIES_DATA', res.data));
    });
  },
  getMytenanciesData: (payload) => {
    getMytenanciesData(payload).then((res) => {
      dispatch(actions.myaccountActions('GET_MYTENANCIES_DATA', res.data));
    });
  },
  getMyoffersData: (payload) => {
    getMyoffersData(payload).then((res) => {
      dispatch(actions.myaccountActions('GET_MYOFFERS_DATA', res.data));
    });
  },
  getMyappointmentsData: (payload) => {
    getMyappointmentsData(payload).then((res) => {
      dispatch(actions.myaccountActions('GET_MYAPPOINTMENTS_DATA', res.data));
    });
  },
  postAppointment: (payload) => {
    postAppointment(payload).then((res) => {
      dispatch(actions.myaccountActions('POST_APPOINTMENTS_SUCCESS', res.data));
    });
  },
  getLatestProperties: (payload) => {
    getProperties(payload).then((res) => {
      dispatch(actions.myaccountActions('GET_LATEST_PROPERTIES', res.data));
    });
  },
  getAllProperties: (payload) => {
    getProperties(payload).then((res) => {
      dispatch(actions.myaccountActions('GET_ALL_PROPERTIES', res.data));
    });
  },
  getProperty: (payload) => {
    dispatch(actions.myaccountActions('DATA_LOADING'));
    getProperty(payload)
      .then((res) => {
        dispatch(actions.myaccountActions('GET_PROPERTY', res.data));
      })
      .catch(() => {
        dispatch(actions.myaccountActions('GET_PROPERTY_FAILED'));
      });
  },
});

export default services;
